import { useEffect, useState } from 'react';

import { authState } from './state';

export const useAuthState = () => {
  const [auth, setAuth] = useState(authState.get());

  // Subscribe to auth state changes
  useEffect(() => {
    const unsubscribe = authState.sub(setAuth);

    return () => {
      unsubscribe();
    };
  }, []);

  return {
    accessToken: auth.accessToken,
    tokenType: auth.tokenType,
    isAuthenticated: !!auth.accessToken && !!auth.tokenType,
    userInfo: auth.userInfo,
  };
};
